<script lang="ts" setup>

// COMPONENTS
import { GButton } from '@flash-global66/g-button';

// COMPOSABLES
import { useRouter } from 'vue-router';

// HELPERS
import { getAsset } from '@/helpers/assets';

// TYPES
import type { IProductCard, IRedirect } from '@/helpers/constants/productCards';

defineProps({
  product: {
    default: {} as IProductCard,
  },
});

const router = useRouter();

async function redirectToProduct(redirect: IRedirect) {
  await router.push(redirect);
  location.reload();
}
</script>

<template>
  <div
    class="flex flex-row p-lg gap-xl bg-sec-def-bg rounded-md shadow-sm"
  >
    <img class="max-w-[80px] w-full" :src="getAsset(product?.img)" :alt="product?.title" />
    <div class="flex flex-col gap-xs">
      <h1 class="font-semibold text-5 text-secondary-txt" v-html="product?.title" />
      <p class="text-4 text-secondary-txt" v-html="product?.subtitle" />
      <g-button
        class="mt-xs"
        @click="redirectToProduct(product?.redirect)"
        :data-test="`button:${product.btnText}`"
      >
        {{ product?.btnText }}
      </g-button>
    </div>
  </div>
</template>
